module.exports = __webpack_public_path__ + "static/media/ic-download-simple.50d6360d.svg";